import { render } from "./Authority.vue?vue&type=template&id=935b4448&scoped=true"
import script from "./Authority.vue?vue&type=script&lang=js"
export * from "./Authority.vue?vue&type=script&lang=js"

import "./Authority.vue?vue&type=style&index=0&id=935b4448&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-935b4448"]])

export default __exports__